import React from 'react'
import './Evaluation.scss'

const Evaluation = () => {
  return (
    <div>Evaluation</div>
  )
}

export default Evaluation